module.exports = __webpack_public_path__ + "img/money-peak-white-error-logo.29a5d2a.png";